import { render } from "./SearchModal.vue?vue&type=template&id=7a46c476&scoped=true&ts=true"
import script from "./SearchModal.vue?vue&type=script&lang=ts"
export * from "./SearchModal.vue?vue&type=script&lang=ts"

import "./SearchModal.vue?vue&type=style&index=0&id=7a46c476&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a46c476"]])

export default __exports__